import RequestPageTwo from "./RequestPageTwo";

const GuestSpeakerReq = () => {
    return (
        <RequestPageTwo title="Guest Speaker Request"
            fetchUrl="/get-guest-speaker-requests"
            editEndpoint="update-guest-speaker-requests"
            deleteEndpoint="guest-speaker-requests"
            statusEndpoint="guest-speaker-requests" />
    );
}

export default GuestSpeakerReq;
